module.exports = __webpack_public_path__ + "img/xmas_ac_light.003b66f.webp";